import type { FaireProductEntity } from "../../entity_types/product";

export const p_sdewebdt4n: FaireProductEntity = {
  token: "p_sdewebdt4n",
  type: "product",
  name: "Large capacity Travel Duffel Puffer Tote Bag for Women, Gym",
  brandToken: "b_3fb7o7n9vq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5cde18fe105f2369690db0619d15cbc85d6939afd2f07cfa65847cc0817b584b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d245880c0c824efc47e5860e484717ba2b22224805cc3c0424690d3f4a6db67f.jpeg",
    "https://cdn.faire.com/fastly/6a76b810a1c376d46d0e6ec302a3719ed03b5057c5f321f882eb60c72773eaa0.jpeg",
    "https://cdn.faire.com/fastly/d7c76f55c43cab89e3c727dbcb829f658935804d56f4f2ac8dc8286dd68faa73.jpeg",
    "https://cdn.faire.com/fastly/7cc248ceb079626d1eb25c92c9c9f5527e89e8216029c9a7b058696849fbdfe7.jpeg",
    "https://cdn.faire.com/fastly/62fcc9d3da4eb36b1ad46ef86f0e9b2df424fbd7ca25f2a82f76347301180a03.jpeg",
    "https://cdn.faire.com/fastly/bbe15990c8d248d4604a9e37cbee87af988dcab3ca782ee63c91f1a9172bfb1b.jpeg",
    "https://cdn.faire.com/fastly/6044d12f01ea1e9f7c52a14d3ec6d45831d3cc91683d6bcb51b89dfa49d87512.jpeg",
    "https://cdn.faire.com/fastly/bd92ea469140a2d2078cd9b228b0526a37b427f0f8b800e90e3879ede5dcc81b.jpeg",
    "https://cdn.faire.com/fastly/a0b009a8564d30b9eaf96b4687d8ccbfb0e3d30c81e4f6ac018d3450234cb574.jpeg",
    "https://cdn.faire.com/fastly/5f961de86b05deed136daa2e8a08c45c528837189e8391a25b248ff30e9fd898.jpeg",
    "https://cdn.faire.com/fastly/af62b731581bd9609ee1476ea5b4658fdb265a10e6ac83871ac7141849ca67d3.jpeg",
    "https://cdn.faire.com/fastly/97b9b2cd91d18048c87f4fa5931695f2799233b89489031ad52c9bd842d7f16e.jpeg",
    "https://cdn.faire.com/fastly/f64a17d5380d5130e3773d8dba7504fbd96ce709b7724ae76cb207c2547e7d7f.jpeg",
    "https://cdn.faire.com/fastly/00392764486e20a339a00ba62c835f211774ae741d0f3caf34c594f7cdf1a0a9.jpeg",
    "https://cdn.faire.com/fastly/5b1b9c23f25cc849770a43d3477274ee72c1606b8090a0fc0c5e5f2b39af45c8.jpeg",
  ],
  priceDollars: 27.7,
  description:
    'Large capacity Travel Duffel Puffer Tote Bag for Women, Gym with Zipper\n✅ Material: Polyester\n✅ Puffy texture to your look.\n✅ Perfect Dimensions: 21.3" (L) × 10.6" (H) × 5.5" (W) (54×27×14cm), roomy for daily essentials.\n✅ Ways: Top handles for hand - held use.\n✅ Secure Storage: Zipper keeps belongings safe;    ideal for work, shopping, or casual outings',
  tags: [],
  msrpDollars: 55.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:29.020Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
